const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/$lang/$family.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from "@tanstack/react-router";
import { parseFeaturePageFamilyPath } from "@garimpa/lib/parseFeaturePageFamilyPath";
export const Route = createFileRoute("/_app/$lang/$family")({
  beforeLoad: ({
    params
  }) => {
    const featurePageFamily = parseFeaturePageFamilyPath(params.family);
    if (!featurePageFamily) throw notFound();
    return {
      featurePageFamily
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});